import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { UzurvDirectivesModule } from '@uzurv/core';
import { AddEditRideMetadataDialogComponent } from './add-edit-ride-metadata-dialog.component';

@NgModule({
  declarations: [AddEditRideMetadataDialogComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    UzurvDirectivesModule
  ],
  exports: [AddEditRideMetadataDialogComponent]
})
export class AddEditRideMetadataDialogModule {}
